import * as React from 'react';
import type { SVGProps } from 'react';
const SvgListSon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M4.833 6.801a.75.75 0 1 0-1.5 0v2.577a2.75 2.75 0 0 0 2.75 2.75h8.12l-.647.647a.688.688 0 0 0 .973.972l1.953-1.953a.69.69 0 0 0 0-.972l-1.959-1.96a.688.688 0 0 0-.972.973l.792.793h-8.26c-.69 0-1.25-.56-1.25-1.25V6.8Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgListSon;
